<template>
  <div>
    <Head title="Categorias de Productos" />
    <h1 class="mb-8 text-3xl font-bold">Categorias</h1>
    <div class="flex items-center justify-between mb-6">
      <search v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <Link class="btn-sky" href="/settings/clients/categories/create">
        <span>Crear</span>
        <span class="hidden md:inline">&nbsp;Categoria</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2">Id</th>
          <th class="pb-4 pt-6 px-2">Code</th>
          <th class="pb-4 pt-6 px-2">Descripción</th>
          <th class="pb-4 pt-6 px-2">Creado</th>
          <th class="pb-4 pt-6 px-2">Estatus</th>
        </tr>

        
        <tr v-for="clientsCategories in clientsCategories.data" :key="clientsCategories.id" class="hover:bg-gray-100 focus-within:bg-gray-100">          
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/clients/categories/${clientsCategories.id}/edit`"> 
              {{ clientsCategories.id }}  
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/clients/categories/${clientsCategories.id}/edit`">
              {{ clientsCategories.code }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/clients/categories/${clientsCategories.id}/edit`">
              {{ clientsCategories.description }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/clients/categories/${clientsCategories.id}/edit`">
              {{ clientsCategories.create }}
            </Link>
          </td> 
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/clients/categories/${clientsCategories.id}/edit`">
              {{ clientsCategories.status }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-6 py-4" :href="`/settings/clients/categories/${clientsCategories.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="clientsCategories.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">No se encontraron categorias.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="clientsCategories.links" />
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import Search from '@/Shared/Search'
import Pagination from '@/Shared/Pagination'
  
export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Search,
    Pagination,
  },
  layout: Layout,
  props: {
    clientsCategories: Array,
    filters: Object,
    codes: Object,  
    categories: Object,

  },
  remember: 'form',
  data() {
    return {
      form: {
        search: this.filters.search,
        code: this.filters.code,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/settings/clients/categories', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>